import { useRouter } from 'common/hooks/useRouter';
import Layout from 'common/Layouts';
import { useTranslation } from 'react-i18next';
import FormSetTwoFactor from './components/form';

const DesktopSetTwoFactor = () => {
  const {
    history: {
      state: { state },
    },
  } = useRouter();

  const { t } = useTranslation();

  const getTitle = () => {
    const pageName = state
      ? t(`FormSide.DisableTwoFactorState`)
      : t(`FormSide.EnableTwoFactorState`);
    const brokerName = t(`BrokerCode_${window.api?.BROKER_CODE}.Title`);
    const separateSymbol = ' - ';
    return pageName + separateSymbol + brokerName;
  };

  return (
    <Layout title={getTitle()}>
      <FormSetTwoFactor />
    </Layout>
  );
};

export default DesktopSetTwoFactor;
